import ProductAddonsView from './product-addons-view'

export default ProductAddonsView
